import { render, staticRenderFns } from "./tabs-pane.vue?vue&type=template&id=aa09e8a2&scoped=true&"
import script from "./tabs-pane.vue?vue&type=script&lang=js&"
export * from "./tabs-pane.vue?vue&type=script&lang=js&"
import style0 from "./tabs-pane.vue?vue&type=style&index=0&id=aa09e8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa09e8a2",
  null
  
)

export default component.exports